import { produce } from 'immer';
import { Notice, SupportedDataType } from '@/core';
import { InternalGetDataResponse } from '../../model';

export type NormalizeDataResponseNoticesOpts<T extends SupportedDataType = SupportedDataType> = {
  data: InternalGetDataResponse<T>;
  pluginNotices: Notice[];
};

/**
 * Immutably normalizes the the `metadata` property on the query result data.
 */
export function normalizeDataResponseNotices<T extends SupportedDataType = SupportedDataType>({
  data,
  pluginNotices,
}: NormalizeDataResponseNoticesOpts<T>) {
  return produce(data, (draft) => {
    if (pluginNotices.length === 0) {
      return draft;
    }
    // Merge in any notices from the plugin
    if (draft.data.metadata === undefined) {
      draft.data.metadata = {};
    }
    if (draft.data.metadata.notices === undefined) {
      draft.data.metadata.notices = [];
    }
    draft.data.metadata.notices.push(...pluginNotices);
  });
}
